import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()

export class ErrorHandlerInterceptor implements HttpInterceptor {

  constructor(private snackbar: MatSnackBar) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(response => {
        const {body} = response as any;
        if (body && body.errors && body.errors.code) {

          this.snackbar.open(body.errors.msg, 'OK', {
            duration: 10000,
          });
        }

      })
    );
  }
}
